import React, { FC } from 'react';
import { Drawer } from 'antd';

interface BottomSheetProps {
  visible: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

const BottomSheet: FC<BottomSheetProps> = ({
  visible,
  title,
  onClose,
  children,
}) => (
  <div className="md:hidden">
    <Drawer
      placement="bottom"
      visible={visible}
      onClose={onClose}
      closable={false}
      className="adhd-bottom-sheet"
      bodyStyle={{ padding: 0 }}
      headerStyle={{ display: 'none' }}
      height="auto"
    >
      <div className="adhd-bottom-sheet__grab" aria-hidden />
      <div className="adhd-bottom-sheet__hd">
        <b>{title}</b>
        <button type="button" className="adhd-bottom-sheet__close" onClick={onClose}>
          Close
        </button>
      </div>
      <div className="adhd-bottom-sheet__bd">
        {children}
      </div>
    </Drawer>
  </div>
);

export default BottomSheet;
